<!-- Overlay do menu -->
<div *ngIf="isOpen" class="absolute inset-0 bg-black bg-opacity-50 z-40" (click)="onCloseMenu()"></div>

<!-- Menu lateral -->
<div
  class="absolute top-0 left-0 h-full w-72 bg-white dark:bg-gray-800 shadow-xl z-50 transform transition-transform duration-300"
  [class.translate-x-0]="isOpen" [class.-translate-x-full]="!isOpen">
  <div class="flex flex-col h-full">
    <!-- Perfil do usuário -->
    <div class="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 py-4 px-4">
      <div class="flex flex-col items-center">
        <div
          class="w-16 h-16 rounded-full border-3 border-blue-200 dark:border-blue-800 bg-gray-100 dark:bg-gray-700 flex items-center justify-center mb-2 overflow-hidden">
          <img *ngIf="userPhoto" [src]="userPhoto" [alt]="userName" class="w-full h-full object-cover" />
          <lucide-icon *ngIf="!userPhoto" name="user" class="w-10 h-10 text-gray-400 dark:text-gray-300"></lucide-icon>
        </div>
        <h3 class="text-base font-bold text-gray-800 dark:text-gray-100 text-center">{{ userName || 'Usuário' }}</h3>
        <span class="text-sm text-gray-500 dark:text-gray-400">{{ userLogin }}</span>
      </div>
    </div>

    <!-- Navegação com scroll -->
    <div class="flex-1 overflow-y-auto">
      <!-- Contexto atual -->
      <div class="bg-gray-50 dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700" *ngIf="contexto">
        <!-- Cabeçalho do contexto (sempre visível) -->
        <div class="px-4 py-3 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
          (click)="toggleContexto()">
          <div class="flex items-center justify-between">
            <div class="flex-1 min-w-0 space-y-2">
              <!-- Estabelecimento -->
              <div class="flex items-center gap-2.5">
                <div
                  class="flex-shrink-0 w-5 h-5 rounded-md border border-orange-500 dark:border-orange-400 flex items-center justify-center">
                  <lucide-icon name="home" class="w-3 h-3 text-orange-600 dark:text-orange-400"></lucide-icon>
                </div>
                <p class="text-sm font-semibold text-gray-900 dark:text-white truncate">
                  {{ contexto.estabelecimento?.descricao || contexto.estabelecimento?.nome || 'Escola não informada' }}
                </p>
              </div>

              <!-- Turma -->
              <div class="flex items-center gap-2.5">
                <div
                  class="flex-shrink-0 w-5 h-5 rounded-md border border-orange-500 dark:border-orange-400 flex items-center justify-center">
                  <lucide-icon name="users" class="w-3 h-3 text-orange-600 dark:text-orange-400"></lucide-icon>
                </div>
                <p class="text-sm font-semibold text-gray-700 dark:text-gray-200 truncate">
                  {{ contexto.turma?.descricao || contexto.turma?.nome || 'Turma não informada' }}
                </p>
              </div>

              <!-- Ano Letivo -->
              <div class="flex items-center gap-2.5">
                <div
                  class="flex-shrink-0 w-5 h-5 rounded-md border border-orange-500 dark:border-orange-400 flex items-center justify-center">
                  <lucide-icon name="calendar" class="w-3 h-3 text-orange-600 dark:text-orange-400"></lucide-icon>
                </div>
                <p class="text-sm font-semibold text-gray-700 dark:text-gray-200 truncate">
                  {{ contexto.anoLetivo?.ano || contexto.anoLetivo?.descricao || 'Ano não informado' }}
                </p>
              </div>
            </div>

            <!-- Ícone de expandir/recolher -->
            <lucide-icon [name]="contextoExpandido ? 'chevron-up' : 'chevron-down'"
              class="w-5 h-5 text-gray-400 dark:text-gray-500 flex-shrink-0 ml-2">
            </lucide-icon>
          </div>
        </div>

        <!-- Detalhes do contexto (expansível) -->
        <div class="px-4 pb-3 space-y-2 border-t border-gray-200 dark:border-gray-700 pt-3" *ngIf="contextoExpandido">
          <!-- Entidade -->
          <div class="text-xs">
            <span class="text-gray-500 dark:text-gray-400 font-medium">Entidade:</span>
            <p class="text-gray-900 dark:text-gray-100 font-medium break-words">{{ contexto.entidade?.nome ||
              contexto.entidade?.name || 'Não informada' }}</p>
          </div>

          <!-- Servidor -->
          <div class="text-xs">
            <span class="text-gray-500 dark:text-gray-400 font-medium">Servidor:</span>
            <p class="text-gray-900 dark:text-gray-100 font-medium break-words">{{ contexto.servidor?.pessoa?.nome ||
              'Não informado' }}</p>
          </div>

          <!-- Disciplinas -->
          <div class="text-xs" *ngIf="getComponentesLength() > 0">
            <span class="text-gray-500 dark:text-gray-400 font-medium block mb-1.5">Componentes curriculares:</span>
            <div class="space-y-1.5">
              <div *ngFor="let componente of contexto?.componentes; let i = index" class="flex items-center space-x-2">
                <div class="w-2.5 h-2.5 rounded-full flex-shrink-0"
                  [style.background-color]="getComponenteColor(componente, i)"></div>
                <span class="text-gray-900 dark:text-gray-100 break-words">{{ componente.descricao || componente.nome
                  }}</span>
              </div>
            </div>
          </div>

          <!-- Botão Alterar Contexto -->
          <button (click)="abrirModalContexto()"
            class="w-full mt-3 flex items-center justify-center space-x-2 px-3 py-2 bg-gradient-to-r from-blue-500 to-blue-600 dark:from-blue-600 dark:to-blue-700 hover:from-blue-600 hover:to-blue-700 dark:hover:from-blue-700 dark:hover:to-blue-800 text-white rounded-lg transition-all duration-200 shadow-sm">
            <lucide-icon name="arrow-left-right" class="w-4 h-4"></lucide-icon>
            <span class="text-sm font-medium">{{ contextActionLabel }}</span>
          </button>
        </div>
      </div>

      <!-- Navegação -->
      <nav>
        <!-- Frequência -->
        <a routerLink="/frequencia" (click)="onCloseMenu()" routerLinkActive="bg-blue-50 dark:bg-blue-900/30"
          class="block px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-700 border-b border-gray-200 dark:border-gray-700 transition-colors">
          <div class="flex items-center space-x-3">
            <lucide-icon name="square-check-big" class="w-5 h-5 text-betha-blue dark:text-blue-400"></lucide-icon>
            <span class="text-gray-700 dark:text-gray-200 font-medium">Frequência</span>
          </div>
        </a>


        <!-- Planejamento de aula -->
        <a routerLink="/planejamento-aula"
           (click)="onCloseMenu()"
           routerLinkActive="bg-blue-50 dark:bg-blue-900/30"
           class="block px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-700 border-b border-gray-200 dark:border-gray-700 transition-colors">
          <div class="flex items-center space-x-3">
            <lucide-icon name="book-open" class="w-5 h-5 text-betha-blue dark:text-blue-400"></lucide-icon>
            <span class="text-gray-700 dark:text-gray-200 font-medium">Planejamento de aula</span>
          </div>
        </a>

        <!-- Conteúdo ministrado -->
        <!-- <div
          class="block px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-700 border-b border-gray-200 dark:border-gray-700 opacity-50 cursor-not-allowed">
          <div class="flex items-center space-x-3">
            <lucide-icon name="book-open-check" class="w-5 h-5 text-gray-400"></lucide-icon>
            <span class="text-gray-500 dark:text-gray-400 font-medium">Conteúdo ministrado</span>
          </div>
        </div> -->

        <!-- Desempenho -->
        <a routerLink="/desempenho" (click)="onCloseMenu()" routerLinkActive="bg-blue-50 dark:bg-blue-900/30"
          class="block px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-700 border-b border-gray-200 dark:border-gray-700 transition-colors">
          <div class="flex items-center space-x-3">
            <lucide-icon name="star" class="w-5 h-5 text-betha-blue dark:text-blue-400"></lucide-icon>
            <span class="text-gray-700 dark:text-gray-200 font-medium">Desempenho</span>
          </div>
        </a>

        <!-- Instrumentos de Avaliação -->
        <a routerLink="/instrumentos-avaliacao" (click)="onCloseMenu()"
          routerLinkActive="bg-blue-50 dark:bg-blue-900/30"
          class="block px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-700 border-b border-gray-200 dark:border-gray-700 transition-colors">
          <div class="flex items-center space-x-3">
            <lucide-icon name="clipboard-check" class="w-5 h-5 text-betha-blue dark:text-blue-400"></lucide-icon>
            <span class="text-gray-700 dark:text-gray-200 font-medium">Instrumentos de avaliação</span>
          </div>
        </a>

        <!-- Devolutivas -->
        <!-- <div
          class="block px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-700 border-b border-gray-200 dark:border-gray-700 opacity-50 cursor-not-allowed">
          <div class="flex items-center space-x-3">
            <lucide-icon name="reply-all" class="w-5 h-5 text-gray-400"></lucide-icon>
            <span class="text-gray-500 dark:text-gray-400 font-medium">Devolutivas</span>
          </div>
        </div> -->

        <!-- Acompanhamento pedagógico -->
        <a routerLink="/acompanhamento-pedagogico" (click)="onCloseMenu()"
          routerLinkActive="bg-blue-50 dark:bg-blue-900/30"
          class="block px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-700 border-b border-gray-200 dark:border-gray-700 transition-colors">
          <div class="flex items-center space-x-3">
            <lucide-icon name="message-circle-more" class="w-5 h-5 text-betha-blue dark:text-blue-400"></lucide-icon>
            <span class="text-gray-700 dark:text-gray-200 font-medium">Acompanhamento pedagógico</span>
          </div>
        </a>

        <!-- Quadro de horários -->
        <!-- <div
          class="block px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-700 border-b border-gray-200 dark:border-gray-700 opacity-50 cursor-not-allowed">
          <div class="flex items-center space-x-3">
            <lucide-icon name="calendar-days" class="w-5 h-5 text-gray-400"></lucide-icon>
            <span class="text-gray-500 dark:text-gray-400 font-medium">Quadro de horários</span>
          </div>
        </div> -->

        <!-- Atividades -->
        <!-- <div
          class="block px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-700 border-b border-gray-200 dark:border-gray-700 opacity-50 cursor-not-allowed">
          <div class="flex items-center space-x-3">
            <lucide-icon name="file-text" class="w-5 h-5 text-gray-400"></lucide-icon>
            <span class="text-gray-500 dark:text-gray-400 font-medium">Atividades</span>
          </div>
        </div> -->

                <!-- Plano de Ensino -->
        <a *ngIf="planoEnsinoDisponivel" routerLink="/plano-ensino" (click)="onCloseMenu()" routerLinkActive="bg-blue-50 dark:bg-blue-900/30"
          class="block px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-700 border-b border-gray-200 dark:border-gray-700 transition-colors">
          <div class="flex items-center space-x-3">
            <lucide-icon name="book-check" class="w-5 h-5 text-betha-blue dark:text-blue-400"></lucide-icon>
            <span class="text-gray-700 dark:text-gray-200 font-medium">Plano de ensino</span>
          </div>
        </a>
      </nav>
    </div>

    <!-- Botões de ação (Configurações e Sair) - FIXED FOOTER -->
    <div class="border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800">
      <!-- Configurações -->
      <button (click)="abrirModalConfiguracoes()"
        class="w-full text-left px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors border-b border-gray-200 dark:border-gray-700">
        <div class="flex items-center space-x-3">
          <lucide-icon name="settings" class="w-5 h-5 text-betha-blue dark:text-blue-400"></lucide-icon>
          <span class="text-gray-700 dark:text-gray-200 font-medium">Configurações</span>
        </div>
      </button>

      <!-- Sair -->
      <button (click)="onLogout()"
        class="w-full text-left px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
        <div class="flex items-center space-x-3">
          <lucide-icon name="log-out" class="w-5 h-5 text-red-600 dark:text-red-400"></lucide-icon>
          <span class="text-gray-700 dark:text-gray-200 font-medium">Sair</span>
        </div>
      </button>
    </div>
  </div>
</div>